var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DropMoleculeCurrencyList"},_vm._l((_vm.currencies),function(quantity,id){return _c('currency-smart',{key:`currency-${id}`,attrs:{"id":+id,"quantity":quantity}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }